export default __webpack_public_path__ + "static/media/logoGregoBiblico.0759af2f.png";